/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';
import type { ApplicationResponsiblePersonSearchOrderBy } from './ApplicationResponsiblePersonSearchOrderBy';
import {
    ApplicationResponsiblePersonSearchOrderByFromJSON,
    ApplicationResponsiblePersonSearchOrderByFromJSONTyped,
    ApplicationResponsiblePersonSearchOrderByToJSON,
    ApplicationResponsiblePersonSearchOrderByToJSONTyped,
} from './ApplicationResponsiblePersonSearchOrderBy';

/**
 * 
 * @export
 * @interface ApplicationResponsiblePersonSearchOrderByPaginationQuery
 */
export interface ApplicationResponsiblePersonSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof ApplicationResponsiblePersonSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ApplicationResponsiblePersonSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof ApplicationResponsiblePersonSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {ApplicationResponsiblePersonSearchOrderBy}
     * @memberof ApplicationResponsiblePersonSearchOrderByPaginationQuery
     */
    orderField?: ApplicationResponsiblePersonSearchOrderBy;
}



/**
 * Check if a given object implements the ApplicationResponsiblePersonSearchOrderByPaginationQuery interface.
 */
export function instanceOfApplicationResponsiblePersonSearchOrderByPaginationQuery(value: object): value is ApplicationResponsiblePersonSearchOrderByPaginationQuery {
    return true;
}

export function ApplicationResponsiblePersonSearchOrderByPaginationQueryFromJSON(json: any): ApplicationResponsiblePersonSearchOrderByPaginationQuery {
    return ApplicationResponsiblePersonSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function ApplicationResponsiblePersonSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : ApplicationResponsiblePersonSearchOrderByFromJSON(json['orderField']),
    };
}

export function ApplicationResponsiblePersonSearchOrderByPaginationQueryToJSON(json: any): ApplicationResponsiblePersonSearchOrderByPaginationQuery {
    return ApplicationResponsiblePersonSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function ApplicationResponsiblePersonSearchOrderByPaginationQueryToJSONTyped(value?: ApplicationResponsiblePersonSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': ApplicationResponsiblePersonSearchOrderByToJSON(value['orderField']),
    };
}

